import ReactNavbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Breadcrumbs } from "components/Breadcrumbs";
import { Button } from "components/Button";
import { PlusIcon as PlusIconImage } from "assets/icons";
import { isLoggedIn } from "utils/index";
import { useNavigation } from "utils/navigate";
import { toggleCreateStrategyModal } from "Layout/slice";
import { STRATEGY_V2_PATH } from "features/Strategy/routes";
import PropTypes from "prop-types";
import { AccountDropdown, HamburgerToggle } from "../Components";

export const NavbarDefault = ({ showHamburger = true }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { navigateToV2Signin } = useNavigation();

  const handleCreateStrategy = () => {
    if (!isLoggedIn()) {
      navigateToV2Signin();
      return;
    }
    dispatch(toggleCreateStrategyModal(true));
  };

  const isStrategyPage = location.pathname === STRATEGY_V2_PATH;

  return (
    <>
      {showHamburger && <HamburgerToggle />}

      <ReactNavbar.Collapse
        id="responsive-navbar-nav"
        className="justify-content-end"
      >
        <Breadcrumbs />

        <Nav>
          {isStrategyPage && (
            <Button size="small" onClick={handleCreateStrategy}>
              <PlusIconImage stroke="white" />
              <div className="btn-text">New strategy</div>
            </Button>
          )}

          <AccountDropdown />
        </Nav>
      </ReactNavbar.Collapse>
    </>
  );
};

NavbarDefault.propTypes = {
  showHamburger: PropTypes.bool,
};
